import { createAction } from 'redux-actions';

// -----------------------------
// Member Set
// -----------------------------

export const doMemberSet = createAction('SET_MEMBER');

// -----------------------------
// Member Fetch
// -----------------------------

export const initMemberFetch = createAction('FETCH_MEMBER_INIT');
export const requestMemberFetch = createAction('FETCH_MEMBER_REQUEST');
export const receiveMemberFetch = createAction('FETCH_MEMBER_RECEIVE');
export const errorMemberFetch = createAction('FETCH_MEMBER_ERROR');
export const finishMemberFetch = createAction('FETCH_MEMBER_FINISH');

// -----------------------------
// Members Fetch by Company
// -----------------------------

export const initMembersFetchByCompany = createAction('FETCH_MEMBERS_BY_COMPANY_INIT');
export const requestMembersFetchByCompany = createAction('FETCH_MEMBERS_BY_COMPANY_REQUEST');
export const receiveMembersFetchByCompany = createAction('FETCH_MEMBERS_BY_COMPANY_RECEIVE');
export const errorMembersFetchByCompany = createAction('FETCH_MEMBERS_BY_COMPANY_ERROR');
export const finishMembersFetchByCompany = createAction('FETCH_MEMBERS_BY_COMPANY_FINISH');

// -----------------------------
// Member Insert
// -----------------------------

export const initMemberInsert = createAction('INSERT_MEMBER_INIT');
export const requestMemberInsert = createAction('INSERT_MEMBER_REQUEST');
export const receiveMemberInsert = createAction('INSERT_MEMBER_RECEIVE');
export const errorMemberInsert = createAction('INSERT_MEMBER_ERROR');
export const finishMemberInsert = createAction('INSERT_MEMBER_FINISH');

// -----------------------------
// Member Update
// -----------------------------

export const initMemberUpdate = createAction('UPDATE_MEMBER_INIT');
export const requestMemberUpdate = createAction('UPDATE_MEMBER_REQUEST');
export const receiveMemberUpdate = createAction('UPDATE_MEMBER_RECEIVE');
export const errorMemberUpdate = createAction('UPDATE_MEMBER_ERROR');
export const finishMemberUpdate = createAction('UPDATE_MEMBER_FINISH');

// -----------------------------
// Member Address Update
// -----------------------------

export const initMemberAddressUpdate = createAction('UPDATE_MEMBER_ADDRESS_INIT');
export const requestMemberAddressUpdate = createAction('UPDATE_MEMBER_ADDRESS_REQUEST');
export const receiveMemberAddressUpdate = createAction('UPDATE_MEMBER_ADDRESS_RECEIVE');
export const errorMemberAddressUpdate = createAction('UPDATE_MEMBER_ADDRESS_ERROR');
export const finishMemberAddressUpdate = createAction('UPDATE_MEMBER_ADDRESS_FINISH');

// -----------------------------
// Member Search
// -----------------------------

export const initMemberSearch = createAction('SEARCH_MEMBERS_INIT');
export const requestMemberSearch = createAction('SEARCH_MEMBERS_REQUEST');
export const receiveMemberSearch = createAction('SEARCH_MEMBERS_RECEIVE');
export const errorMemberSearch = createAction('SEARCH_MEMBERS_ERROR');
export const finishMemberSearch = createAction('SEARCH_MEMBERS_FINISH');
